import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../modules/apps/dashboard/DashboardWrapper'
import {DashboardForecastWrapper} from '../modules/dashboard-forecast/DashboardForecastWrapper'
import PartnerOrganizationPage from '../modules/partner-organization/PartnerOrganizationPage'
import {RushHourWrapper} from '../modules/report-rush-hour/RushHourWrapper'
import {TrendAnalysisWrapper} from '../modules/report-trend-analysis/TrendAnalysisWrapper'
import {RevenueSharingWrapper} from '../modules/revenue-sharing/RevenueSharingWrapper'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import ProductModiferPage from '@/app/modules/product-modifier/ProductModifierPage'
import SubscriptionPage from '@/app/modules/subscription/SubscriptionPage'
import SubscriptionHistoryPage from '../modules/subscription-history/SubscriptionHistoryPage'
import TopupHistoryPage from '../modules/topup-history/TopupHisotryPage'
// import TransactionSummaryPage from '../modules/transaction-summary/TransactionSummaryPage'

const PrivateRoutesCustomer = () => {

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/not-found' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutesCustomer}
